import Image from "next/image";
import imgVoiceBg01 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 01.png";
import imgVoiceBg02 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 02.png";
import imgVoiceBg03 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 03.png";
import imgVoiceBg04 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 04.png";
import imgVoiceBg05 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 05.png";
import imgVoiceBg06 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 06.png";
import imgVoiceBg07 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 07.png";
import imgVoiceBg08 from "@/app/_blocks/BlockVoicesSlider/images/Voice BG 08.png";

const VOICE_IMAGES = [
  imgVoiceBg01,
  imgVoiceBg02,
  imgVoiceBg03,
  imgVoiceBg04,
  imgVoiceBg05,
  imgVoiceBg06,
  imgVoiceBg07,
  imgVoiceBg08,
];

interface VoiceAvatarProps extends Omit<React.ComponentPropsWithRef<typeof Image>, "src" | "alt" | "placeholder"> {
  index: number;
  seed?: string;
}

function stringToUnitFloat(str: string) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0) / 4294967295;
}

function createRandom(seed: string) {
  let i = Math.round(stringToUnitFloat(seed) * 10000);
  return function random() {
    const x = Math.sin(i++) * 10000;
    return x - Math.floor(x);
  };
}

export function getVoiceAvatarImage({ index, seed }: { index: number; seed?: string }) {
  let images = VOICE_IMAGES;

  if (typeof seed === "string") {
    // Use `seed` to shuffle the images deterministically
    const random = createRandom(seed);
    images = images
      .map(value => ({ value, sort: random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  }

  const avatarImage = images[index % images.length];

  return avatarImage;
}

export function VoiceAvatar({ index, seed, ...props }: VoiceAvatarProps) {
  return <Image src={getVoiceAvatarImage({ index, seed })} placeholder='blur' alt='' {...props} />;
}
